export var CourseStateActions;
(function (CourseStateActions) {
  let Initialize = /*#__PURE__*/(() => {
    class Initialize {
      static {
        this.type = '[Course] Initialize';
      }
      constructor() {}
    }
    return Initialize;
  })();
  CourseStateActions.Initialize = Initialize;
  let ReloadCourses = /*#__PURE__*/(() => {
    class ReloadCourses {
      static {
        this.type = '[Course] Reload Courses';
      }
      constructor() {}
    }
    return ReloadCourses;
  })();
  CourseStateActions.ReloadCourses = ReloadCourses;
  let ReloadProgressAll = /*#__PURE__*/(() => {
    class ReloadProgressAll {
      static {
        this.type = '[Course] Reload Progress All';
      }
      constructor() {}
    }
    return ReloadProgressAll;
  })();
  CourseStateActions.ReloadProgressAll = ReloadProgressAll;
  let ReloadCourseProgress = /*#__PURE__*/(() => {
    class ReloadCourseProgress {
      static {
        this.type = '[Course] Reload Course Progress';
      }
      constructor() {}
    }
    return ReloadCourseProgress;
  })();
  CourseStateActions.ReloadCourseProgress = ReloadCourseProgress;
  let SelectCourse = /*#__PURE__*/(() => {
    class SelectCourse {
      static {
        this.type = '[Course] Select Course';
      }
      constructor(id) {
        this.id = id;
      }
    }
    return SelectCourse;
  })();
  CourseStateActions.SelectCourse = SelectCourse;
  let SelectScene = /*#__PURE__*/(() => {
    class SelectScene {
      static {
        this.type = '[Course] Select A Scene';
      }
      constructor(id) {
        this.id = id;
      }
    }
    return SelectScene;
  })();
  CourseStateActions.SelectScene = SelectScene;
  let SelectNextScene = /*#__PURE__*/(() => {
    class SelectNextScene {
      static {
        this.type = '[Course] Select Next Scene';
      }
      constructor(skipCompletedScenes = false) {
        this.skipCompletedScenes = skipCompletedScenes;
      }
    }
    return SelectNextScene;
  })();
  CourseStateActions.SelectNextScene = SelectNextScene;
  let ClearSelectedCourse = /*#__PURE__*/(() => {
    class ClearSelectedCourse {
      static {
        this.type = '[Course] Clear Selected Course';
      }
      constructor() {}
    }
    return ClearSelectedCourse;
  })();
  CourseStateActions.ClearSelectedCourse = ClearSelectedCourse;
  let ClearSelectedScene = /*#__PURE__*/(() => {
    class ClearSelectedScene {
      static {
        this.type = '[Course] Clear Selected Scene';
      }
      constructor() {}
    }
    return ClearSelectedScene;
  })();
  CourseStateActions.ClearSelectedScene = ClearSelectedScene;
  let SaveCurrentSceneProgress = /*#__PURE__*/(() => {
    class SaveCurrentSceneProgress {
      static {
        this.type = '[Course] Update Current Scene Progress';
      }
      constructor(progress) {
        this.progress = progress;
      }
    }
    return SaveCurrentSceneProgress;
  })();
  CourseStateActions.SaveCurrentSceneProgress = SaveCurrentSceneProgress;
  let Internal_UpdateSceneProgressFromServer = /*#__PURE__*/(() => {
    class Internal_UpdateSceneProgressFromServer {
      static {
        this.type = '[Course] (Internal) Update Scene Progress From Server';
      }
      constructor(progressItem) {
        this.progressItem = progressItem;
      }
    }
    return Internal_UpdateSceneProgressFromServer;
  })();
  CourseStateActions.Internal_UpdateSceneProgressFromServer = Internal_UpdateSceneProgressFromServer;
  let SetListFilters = /*#__PURE__*/(() => {
    class SetListFilters {
      static {
        this.type = '[Course] Set List Filters';
      }
      constructor(settings) {
        this.settings = settings;
      }
    }
    return SetListFilters;
  })();
  CourseStateActions.SetListFilters = SetListFilters;
  let ResetListFilters = /*#__PURE__*/(() => {
    class ResetListFilters {
      static {
        this.type = '[Course] Reset List Filters';
      }
      constructor() {}
    }
    return ResetListFilters;
  })();
  CourseStateActions.ResetListFilters = ResetListFilters;
})(CourseStateActions || (CourseStateActions = {}));
// export UserActions;